import PublicPageHeader from "@layouts/public_layout/sub_components/public_page_header"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import LoginForm from "@pages/public/login/sub_components/login_form"

import { useLoginPageContext } from "@contexts/public/login_page_context"
import styles from "./styles"

export default function LoginPage() {
  const { onSubmit, loading, translate } = useLoginPageContext()

  return (
    <Box sx={styles.container}>
      <Stack gap={1} flex={1}>
        <PublicPageHeader
          title={translate("login_page_login")}
          caption={translate("login_page_hint")}
        />
        <LoginForm onSubmit={onSubmit} loading={!!loading} />
      </Stack>
    </Box>
  )
}
